import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Settings from "@/pages/Settings";
import BusinessProfile from "@/pages/BusinessProfile";
import Audit from "@/pages/Audit";
import CampaignPlan from "@/pages/CampaignPlan";
import LandingPages from "@/pages/LandingPages";
import LandingEditor from "@/pages/LandingEditor";
import PublicLanding from "@/pages/PublicLanding";
import Legal from "@/pages/Legal";
import Dashboard from "@/pages/Dashboard";
import Approvals from "@/pages/Approvals";
import Builder from "@/pages/Builder";
import Leads from "@/pages/Leads";
import Changes from "@/pages/Changes";
import LaunchReport from "@/pages/LaunchReport";
import { Spinner } from "@/components/common";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="grid min-h-screen place-items-center"><Spinner /></div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/lp/:slug" element={<PublicLanding />} />
            <Route path="/privacy" element={<Legal kind="privacy" />} />
            <Route path="/terms" element={<Legal kind="terms" />} />
            <Route element={<Protected><Layout /></Protected>}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/launch-report" element={<LaunchReport />} />
              <Route path="/approvals" element={<Approvals />} />
              <Route path="/builder" element={<Builder />} />
              <Route path="/leads" element={<Leads />} />
              <Route path="/changes" element={<Changes />} />
              <Route path="/landing-pages" element={<LandingPages />} />
              <Route path="/landing-pages/:id" element={<LandingEditor />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/profile" element={<BusinessProfile />} />
              <Route path="/audit" element={<Audit />} />
              <Route path="/plan" element={<CampaignPlan />} />
            </Route>
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </AuthProvider>
        <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#0e1526", border: "1px solid #1e293b", color: "#e2e8f0" } }} />
      </BrowserRouter>
    </div>
  );
}

export default App;
